import React from "react";
import useSequences from "../hooks/useSequences";
import useCrmSettings from "../hooks/useCrmSettings";
import CrmLoadFailure from "../ui/CrmLoadFailure";
import SequenceCard from "./SequenceCard";
import { CRM } from "../../../constants/testIds/crm";

/**
 * The five system sequences plus any custom ones (spec Screen 6), one SequenceCard each.
 * The review moment's session count is the practice setting (`settings.crm.
 * review_threshold`), read here once for every card on that trigger; until it loads (or
 * if it cannot), a card falls back to the trigger's plain name.
 */
export default function SequenceGrid({ onDuplicated }) {
  const { rows, loadError, reload, toggle, duplicate } = useSequences();
  const { settings } = useCrmSettings();

  if (loadError) return <CrmLoadFailure error={loadError} onRetry={reload} testId={CRM.emailError} />;

  return (
    <div data-testid={CRM.emailSeqGrid} className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {rows.map((s) => (
        <SequenceCard key={s.id} sequence={s} onToggle={toggle} reviewThreshold={settings?.review_threshold}
          onDuplicate={async (id) => { const copy = await duplicate(id); onDuplicated?.(copy); return copy; }} />
      ))}
    </div>
  );
}
